import { render, staticRenderFns } from "./SelfAssessmentRecoveryTest.vue?vue&type=template&id=d55bc3be&scoped=true&"
import script from "./SelfAssessmentRecoveryTest.vue?vue&type=script&lang=ts&"
export * from "./SelfAssessmentRecoveryTest.vue?vue&type=script&lang=ts&"
import style0 from "./SelfAssessmentRecoveryTest.vue?vue&type=style&index=0&id=d55bc3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55bc3be",
  null
  
)

export default component.exports